export default __webpack_public_path__ + "static/media/img-slider-urban-transit-8.58b3b2f3.png";